import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

import { AdFoxContainer } from '../AdFox';
import { selectUserIsAgent } from '../../../selectors/user';
import { selectAdfoxInfo } from '../../../selectors/newbuilding';

export const StretchBannerContainer = (): React.ReactPortal | null => {
  const [stretchBannerDomElement, setStretchBannerDomElement] = React.useState<HTMLElement | null>(null);
  const isAgent = useSelector(selectUserIsAgent);
  const adfoxInfo = useSelector(selectAdfoxInfo);
  const agentMark = isAgent ? 'agent' : 'not_agent';
  const params = {
    ...adfoxInfo,
    p1: 'bvknz',
    p2: 'y',
    puid10: agentMark,
  };

  React.useEffect(() => {
    setStretchBannerDomElement(document.getElementById('stretch-banner'));
  }, []);

  if (!stretchBannerDomElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <AdFoxContainer ownerId={202100} disableYan={isAgent} params={params} height={200} width="100%" />,
    stretchBannerDomElement,
  );
};
